import { motion, AnimatePresence } from 'motion/react';

export const RECENT_HITS_CAP = 12;

export interface RecentHit {
  id: string;
  label: string;
  color: string;
  /** Zero-payout tier — grey chip needs light text. */
  dim: boolean;
}

/** Prepend a settled hit, newest first, capped — pure so the cap rule is testable. */
export function pushRecentHit(list: RecentHit[], hit: RecentHit): RecentHit[] {
  return [hit, ...list].slice(0, RECENT_HITS_CAP);
}

/**
 * Stake-style last-hits rail overlaying the right edge of the board: every landing pushes
 * its multiplier chip in from the top, so a rapid-fire session reads as a cascading feed.
 */
export function PlinkoRecentHits({ hits }: { hits: RecentHit[] }) {
  if (hits.length === 0) return null;
  return (
    <div
      className="pointer-events-none absolute right-1.5 top-1.5 z-10 flex w-11 flex-col gap-1 sm:right-2.5 sm:top-2.5"
      aria-hidden
      data-plinko-recent
    >
      <AnimatePresence initial={false}>
        {hits.map((h) => (
          <motion.div
            key={h.id}
            layout
            initial={{ opacity: 0, x: 16, scale: 0.6 }}
            animate={{ opacity: 1, x: 0, scale: 1 }}
            exit={{ opacity: 0, scale: 0.5 }}
            transition={{ duration: 0.18, ease: 'easeOut' }}
            className={[
              'grid h-7 place-items-center rounded-md text-[10.5px] font-extrabold tabular-nums shadow-[0_2px_6px_rgba(0,0,0,0.35)]',
              h.dim ? 'text-white/55' : 'text-black/85',
            ].join(' ')}
            style={{ background: h.color }}
          >
            {h.label}
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
}
